/**
 * Service to do CRUD operations about an accounting document's data.
 * It handles requests in an async way.
 *
 * @abstract
 */
export default class AccountingDocumentService {
	fetchInitialData() {
		return Promise.resolve({});
	}
}
